import { useNavigate, useParams } from 'react-router-dom';
import { galleryCrumbToDisplayCrumb } from '../../breadcrumbs/breadcrumbs';
import { GalleryPage } from '../../gallery-page/gallery-page';
import styles from './year-page.module.css';
import { useGetCalendarYearPageQuery } from '../../app/api/pages';
import { PageTitle } from '../page-title/page-title';
import { Spinner } from '../../spinner/spinner';

export const YearPage = () => {
  const { year } = useParams<{ year: string }>();
  const { data, isLoading } = useGetCalendarYearPageQuery({
    year: +(year ?? '2023'),
  });
  const crumbs = [
    { display: 'Gallery', link: '/' },
    ...(data?.crumbs?.map(galleryCrumbToDisplayCrumb) ?? []),
    { display: data?.title ?? '', link: '' },
  ];
  const navigate = useNavigate();
  return (
    <div className={styles.yearPage}>
      <PageTitle
        title={data?.title}
        backLink={{
          to: crumbs[crumbs.length - 2].link,
          label: crumbs[crumbs.length - 2].display,
        }}
        crumbs={crumbs}
      />
      {isLoading && <Spinner />}
      {!isLoading && data && (
        <GalleryPage
          onItemClicked={(item) => {
            switch (item.type) {
              case 'month':
                navigate(`/year/${year}/month/${item.id}`);
                break;

              default:
                console.error(`Unsupported item type: ${item.type}`);
            }
          }}
          {...data}
        />
      )}
    </div>
  );
};
